import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import AuthModals from "../components/AuthModals";
import WeeklyPopup from "../components/WeeklyPopup";
import Hero from "../components/sections/Hero";
import HowItWorks from "../components/sections/HowItWorks";
import SecondLien from "../components/sections/SecondLien";
import RinseRepeat from "../components/sections/RinseRepeat";
import STRStrategy from "../components/sections/STRStrategy";
import SubmitDeal from "../components/sections/SubmitDeal";
import WhyDSCR from "../components/sections/WhyDSCR";
import Partners from "../components/sections/Partners";
import Testimonials from "../components/sections/Testimonials";
import CaseStudies from "../components/sections/CaseStudies";
import DealsSection from "../components/sections/DealsSection";
import Calculator from "../components/sections/Calculator";
import DealAlerts from "../components/sections/DealAlerts";
import Blog from "../components/sections/Blog";
import FAQ from "../components/sections/FAQ";
import StrategySession from "../components/sections/StrategySession";
import useReveal from "../hooks/useReveal";

export default function LandingPage() {
  useReveal([]);
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <HowItWorks />
        <SecondLien />
        <RinseRepeat />
        <STRStrategy />
        <WhyDSCR />
        <Partners />
        <Testimonials />
        <CaseStudies />
        <DealsSection />
        <StrategySession />
        <Calculator />
        <DealAlerts />
        <Blog />
        <FAQ />
        <SubmitDeal />
      </main>
      <Footer />
      <AuthModals />
      <WeeklyPopup />
    </>
  );
}
